import React from 'react';
import { useLocation,useHistory } from 'react-router-dom';
import configs from '../../configs/apiConfigs';
import moment from 'moment';

const ThankYou = () => {
  const location = useLocation();
  const history = useHistory();
  const {
    clinicName = '',
    providerName = '',
    consultationType = null,
    date = null,
    slot = null,
    flexibleSlot = null,
    day = null,
    patient = null,
    path
  } = location.state || {} as any;

  return (
    <div style={{ maxWidth: '800px', margin: '0 auto', padding: '2rem', fontFamily: 'Roboto, sans-serif', backgroundColor: '#f5f5f5', minHeight: '100vh' }}>
      <div style={{ background: 'white', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)', marginBottom: '1.5rem', overflow: 'hidden' }}>
        <div style={{ background: '#fff8e1', padding: '2rem', textAlign: 'center' }}>
          <div style={{ width: '80px', height: '80px', background: '#fff3c4', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 1rem', fontSize: '2.5rem', color: '#f57c00' }}>🕐</div>
          <h1 style={{ fontSize: '2rem', fontWeight: 'bold', marginBottom: '1rem', color: '#333' }}>Request Submitted!</h1>
          <p style={{ color: '#666', marginBottom: '1.5rem', lineHeight: '1.6' }}>
            Your appointment request has been submitted successfully. The clinic will confirm your appointment shortly.
          </p>
          <div style={{ display: 'inline-flex', alignItems: 'center', background: '#fff3c4', color: '#f57c00', padding: '0.5rem 1rem', borderRadius: '20px', fontSize: '0.875rem', gap: '0.5rem' }}>
            <span>🕐</span>
            Status: Awaiting confirmation from clinic
          </div>
        </div>
      </div>

      <div style={{ background: 'white', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)', marginBottom: '1.5rem', overflow: 'hidden' }}>
        <div style={{ background: '#f5f5f5', padding: '1rem 1.5rem', borderBottom: '1px solid #e0e0e0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h2 style={{ fontSize: '1.25rem', fontWeight: 'bold', margin: 0 }}>Requested Appointment Details</h2>
        </div>
        <div style={{ padding: '1.5rem' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' }}>
            <span style={{ color: '#666', width: '20px', textAlign: 'center', fontSize: '1rem' }}>👤</span>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <div style={{ fontWeight: 'bold', marginBottom: '0.25rem' }}>{(patient?.fname || patient?.firstName || patient?.name || '') + ' ' + (patient?.lname || patient?.lastName || '')}</div>
              <div style={{ color: '#666', fontSize: '0.875rem' }}>{consultationType?.name ?? ''}</div>
            </div>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' }}>
            <span style={{ color: '#666', width: '20px', textAlign: 'center', fontSize: '1rem' }}>📅</span>
            <span>{date ? moment.parseZone(date).format("D MMMM YYYY") : ""}</span>
          </div>

          {flexibleSlot && day && (
            <>
              <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' }}>
                <div className="confirm-text-item-title">Preferred days</div>
              <span style={{ color: '#666', width: '20px', textAlign: 'center', fontSize: '1rem' }}>🕐</span>
              <span>{day?.toString()} – {flexibleSlot}</span>
            </div>
            </>
          )}

          {slot && (
            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' }}>
              <span style={{ color: '#666', width: '20px', textAlign: 'center', fontSize: '1rem' }}>🕐</span>
              <span>{slot.startTime} – {slot.endTime}</span>
            </div>
          )}

          {patient?.email && (
            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' }}>
              <span style={{ color: '#666', width: '20px', textAlign: 'center', fontSize: '1rem' }}>✉️</span>
              <span>{patient.email}</span>
            </div>
          )}

          {patient?.phone && (
            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' }}>
              <span style={{ color: '#666', width: '20px', textAlign: 'center', fontSize: '1rem' }}>📞</span>
              <span>{patient.phone}</span>
            </div>
          )}

          {slot?.notes && (
            <div style={{ marginTop: '1.5rem' }}>
              <div style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>Additional Notes:</div>
              <div style={{ color: '#666', fontSize: '0.875rem' }}>{slot.notes}</div>
            </div>
          )}
        </div>
      </div>

      <div style={{
    background: 'white',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    marginBottom: '1.5rem',
    overflow: 'hidden'
  }}>
        <div style={{
    background: '#f3e5f5',
    textAlign: 'center',
    padding: '2rem'
  }}>
          <div style={{
    fontSize: '3rem',
    color: '#9c27b0',
    marginBottom: '1rem'
  }}>🎁</div>
          <h3 style={{
    fontSize: '1.25rem',
    fontWeight: 'bold',
    marginBottom: '1rem',
    margin: '0 0 1rem 0'
          }}>Don't Miss Out! Join Xcare Rewards</h3>
          <p style={{
    color: '#666',
    marginBottom: '1rem',
    lineHeight: '1.6'
  }}>
            Earn points for your confirmed visit — and unlock perks like gift cards, discounts, and more!
          </p>
          <div style={{
    marginBottom: '1.5rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.5rem'
  }}>
            <span>👉</span>
            <span>Join Now — It's free and takes less than a minute!</span>
          </div>
          <a href={configs?.REWARDS_URL} target="_blank" rel="noopener noreferrer">
          <button 
            style={{
              border: 'none',
              padding: '0.75rem 2rem',
              borderRadius: '24px',
              fontSize: '1rem',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              fontWeight: '500',
              background: '#9c27b0',
              color: 'white'
            }}
            onMouseOver={(e: any) => e.target.style.background = '#7b1fa2'}
            onMouseOut={(e: any) => e.target.style.background = '#9c27b0'}
          >
            Join Xcare Rewards
          </button>
          </a>
        </div>
      </div>

      <div style={{ background: 'white', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)', marginBottom: '1.5rem', overflow: 'hidden' }}>
        <div style={{ padding: '1.5rem' }}>
          <h3 style={{ fontSize: '1.25rem', fontWeight: 'bold', marginBottom: '1.5rem' }}>Office Information</h3>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' }}>
            <span style={{ color: '#666', width: '20px', textAlign: 'center', fontSize: '1rem' }}>📍</span>
            <div>
              <div style={{ fontWeight: 'bold', marginBottom: '0.25rem' }}>{clinicName || providerName}</div>
            </div>
          </div>
        </div>
      </div>

      <div style={{ background: 'white', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)', marginBottom: '1.5rem', overflow: 'hidden' }}>
        <div style={{ background: '#e3f2fd', padding: '1.5rem' }}>
          <h3 style={{ color: '#1976d2', fontSize: '1.25rem', fontWeight: 'bold', marginBottom: '1rem' }}>What happens next?</h3>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
            <li style={{ marginBottom: '0.5rem', display: 'flex', alignItems: 'flex-start', gap: '0.5rem' }}><span style={{ color: '#1976d2', fontWeight: 'bold' }}>•</span><span>The clinic will review your request and confirm your appointment</span></li>
            <li style={{ marginBottom: '0.5rem', display: 'flex', alignItems: 'flex-start', gap: '0.5rem' }}><span style={{ color: '#1976d2', fontWeight: 'bold' }}>•</span><span>You'll receive a confirmation email and SMS within 24 hours</span></li>
            <li style={{ marginBottom: '0.5rem', display: 'flex', alignItems: 'flex-start', gap: '0.5rem' }}><span style={{ color: '#1976d2', fontWeight: 'bold' }}>•</span><span>If confirmed, arrive 15 minutes early with photo ID and insurance card</span></li>
            <li style={{ marginBottom: '0.5rem', display: 'flex', alignItems: 'flex-start', gap: '0.5rem' }}><span style={{ color: '#1976d2', fontWeight: 'bold' }}>•</span><span>For questions, call the clinic</span></li>
          </ul>
        </div>
      </div>

      <div style={ {
    display: 'flex',
    gap: '1rem',
    marginBottom: '1.5rem'
  }}>
        <button 
          style={{ border: 'none',
            padding: '0.75rem 2rem',
            borderRadius: '24px',
            fontSize: '1rem',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            fontWeight: '500',
            flex: 1,
            background: 'white',
            color: '#333'}}
          onMouseOver={(e: any) => e.target.style.background = '#f5f5f5'}
          onMouseOut={(e: any) => e.target.style.background = 'white'}
          onClick={() => history.push(path)}
        >
          Request Another Appointment
        </button>
        <button 
          style={{ border: 'none',
            padding: '0.75rem 2rem',
            borderRadius: '24px',
            fontSize: '1rem',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            fontWeight: '500',
            flex: 1,
            background: '#9c27b0',
            color: 'white'}}
          onMouseOver={(e: any) => e.target.style.background = '#7b1fa2'}
          onMouseOut={(e: any) => e.target.style.background = '#9c27b0'}
          onClick={() => window.print()}
        >
          🖨️ Print Request
        </button>
      </div>
    </div>
  );
};

export default ThankYou;
